export default "__VITE_ASSET__B5TjmcM1__"